/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_VerdictInputs */

const en_fc_home_review_verdict = /** @type {(inputs: Fc_Home_Review_VerdictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft is worth exploring for learning, personal projects and a familiar editing workflow without a software subscription. Test your media and export requirements before relying on it for client work.`)
};

/**
* | output |
* | --- |
* | "FilmCraft is worth exploring for learning, personal projects and a familiar editing workflow without a software subscription. Test your media and export requ..." |
*
* @param {Fc_Home_Review_VerdictInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_verdict = /** @type {((inputs?: Fc_Home_Review_VerdictInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_VerdictInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_verdict(inputs)
});
export { fc_home_review_verdict as "fc.home.review.verdict" }